import { SITE_CARE_MODES } from '../../../constants/siteCareModes';

export function buildSettingsStats(sites, currentCentral) {
  const total = sites.length;
  const active = sites.filter((s) => s.is_active).length;
  const withPharmacy = sites.filter(
    (s) => s.has_local_pharmacy || s.site_care_mode === SITE_CARE_MODES.WITH_PHARMACY
  ).length;

  return {
    total,
    active,
    inactive: total - active,
    withPharmacy,
    centralName: currentCentral?.name || null,
    centralId: currentCentral?.id ?? null
  };
}

export function filterSettingsSites(sites, search) {
  const q = (search || '').trim().toLowerCase();
  if (!q) return sites;
  return sites.filter(
    (s) =>
      s.name?.toLowerCase().includes(q) ||
      s.address?.toLowerCase().includes(q) ||
      String(s.site_care_mode || '').toLowerCase().includes(q)
  );
}
